// @flow
import {
  DELETE_PROBLEM_LOADING,
  DELETE_PROBLEM_SUCCESS,
  DELETE_PROBLEM_ERROR,
  ADD_PROBLEM_OLD_LOADING,
  ADD_PROBLEM_OLD_SUCCESS,
  ADD_PROBLEM_OLD_ERROR,
  ADD_PROBLEM_LOADING,
  ADD_PROBLEM_SUCCESS,
  ADD_PROBLEM_ERROR,
  UPDATE_PROBLEM_LOADING,
  UPDATE_PROBLEM_SUCCESS,
  UPDATE_PROBLEM_ERROR,
} from '../actions/problemActions';

export default (state: Object = {}, action: Object) => {
  switch (action.type) {
    case DELETE_PROBLEM_LOADING:
    case ADD_PROBLEM_OLD_LOADING:
    case ADD_PROBLEM_LOADING:
    case UPDATE_PROBLEM_LOADING:
      return {
        ...state,
        status: 'LOADING',
      };
    case DELETE_PROBLEM_SUCCESS:
    case ADD_PROBLEM_OLD_SUCCESS:
    case ADD_PROBLEM_SUCCESS:
    case UPDATE_PROBLEM_SUCCESS:
      return {
        ...state,
        status: 'SUCCESS',
        data: action.data,
      };
    case DELETE_PROBLEM_ERROR:
    case ADD_PROBLEM_OLD_ERROR:
    case ADD_PROBLEM_ERROR:
    case UPDATE_PROBLEM_ERROR:
      return {
        ...state,
        status: 'ERROR',
        error: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/problemReducer.js